<div class="toolbar">
  <ng-container *ngIf="!toolbarReadOnly">
    <div class="reportId" *ngIf="reportOid">
      <label>{{reportOid}}</label>
    </div>
    <div class="languageDropDown">
      <kendo-dropdownlist style="width: 100%;"
                          [(ngModel)]="selectedLanguageId"
                          [data]="availableLanguages"
                          textField="description"
                          valueField="id"
                          [valuePrimitive]="true"
                          (ngModelChange)="languageChanged()">
      </kendo-dropdownlist>
    </div>
    <div class="separator"></div>
    <button class="toolbarItem" [disabled]="!enableButtonToggleEditMode" (click)="toggleEditMode()" [class.toggled]="(rdStorage.appEditMode$ | async)" [attr.title]="'toolbar.buttonToggleEditMode' | translate | uppercase">
      <span class="k-icon k-i-edit k-icon-gray" [class.k-state-selected]="(rdStorage.appEditMode$ | async)"></span>
    </button>
    <button class="toolbarItem" [disabled]="!enableButtonToggleWidgetHeaderMode" (click)="toggleHeaderMode()" [class.toggled]="(rdStorage.appWidgetHeaderMode$ | async)" [attr.title]="'toolbar.buttonToggleWidgetHeaderMode' | translate | uppercase">
      <span class="k-icon k-i-table-row-insert-above k-icon-gray" [class.k-state-selected]="(rdStorage.appWidgetHeaderMode$ | async)"></span>
    </button>
    <button class="toolbarItem" *ngIf="(rdStorage.appWidgetHeaderMode$ | async)" (click)="toggleGridRasterMode()" [class.toggled]="(rdStorage.appReportGridRasterMode$ | async)" [attr.title]="'toolbar.buttonToggleGridRasterMode' | translate | uppercase">
      <span class="k-icon k-i-borders-all"></span>
    </button>
    <button class="toolbarItem" (click)="toggleWidgetListMode()" [class.toggled]="widgetListMode" [attr.title]="'toolbar.buttonToggleWidgetListMode' | translate | uppercase">
      <span class="k-icon k-i-thumbnails-left k-icon-gray" [class.k-state-selected]="widgetListMode"></span>
    </button>
    <button class="toolbarItem" (click)="toggleWidgetInfoMode()" [class.toggled]="widgetInfoMode" [attr.title]="'toolbar.buttonToggleWidgetInfoMode' | translate | uppercase">
      <span class="k-icon k-i-thumbnails-right k-icon-gray" [class.k-state-selected]="widgetInfoMode"></span>
    </button>
    <button class="toolbarItem" [disabled]="!enableButtonShowPageNavigation" (click)="showPageNavigation()" [attr.title]="'toolbar.buttonShowPageNavigation' | translate | uppercase">
      <span class="k-icon k-i-layout-1-by-4"></span>
    </button>
    <button *ngIf="showButtonNewDocument" [disabled]="!enableButtonNewDocument" class="toolbarItem" (click)="createTemplate()" [attr.title]="'toolbar.buttonNewDocument' | translate | uppercase">
      <span class="k-icon k-i-file-add"></span>
    </button>
    <button *ngIf="showButtonLoadDocument" class="toolbarItem" [disabled]="!enableButtonLoadDocument" (click)="loadTemplate()" [attr.title]="'toolbar.buttonLoadDocument' | translate | uppercase">
      <span class="k-icon k-i-file-bac"></span>
      <!--buttonLoadDocument-->
    </button>
    <button *ngIf="showButtonSaveDocument" class="toolbarItem" [disabled]="!enableButtonSaveDocument" (click)="saveDocument()" [attr.title]="'toolbar.buttonSaveDocument' | translate | uppercase">
      <span class="k-icon k-i-save"></span>
      <!--buttonSaveDocument-->
    </button>
    <button *ngIf="showButtonDeleteDocument" class="toolbarItem" [disabled]="!enableButtonDeleteDocument" (click)="deleteTemplate()" [attr.title]="'toolbar.buttonDeleteDocument' | translate | uppercase">
      <span class="k-icon k-i-delete"></span>
      <!--buttonDeleteDocument-->
    </button>
    <button *ngIf="showButtonTranslateWidgets" class="toolbarItem" (click)="translateWidgets()" [disabled]="!enableButtonTranslateWidgets" [attr.title]="'toolbar.buttonTranslateWidgets' | translate | uppercase">
      <span class="k-icon k-i-wrench"></span>
    </button>
    <button *ngIf="showButtonSaveReport" class="toolbarItem" [disabled]="!enableButtonSaveReport" (click)="saveReport()" [attr.title]="'toolbar.buttonSaveReport' | translate | uppercase">
      <span class="k-icon k-i-save"></span>
      <!--buttonSaveReport-->
    </button>
    <div class="separator" *ngIf="reportOid"></div>
    <button class="toolbarItem" *ngIf="!(rdStorage.appEditMode$ | async) && !(rdStorage.appWidgetHeaderMode$ | async)" [attr.title]="'toolbar.buttonPrintDocument' | translate | uppercase" (click)="printReport()">
      <span class="k-icon k-i-pdf"></span>
      <!--buttonPrintDocument-->
    </button>
    <button class="toolbarItem hashtagsNavigatorButton" (click)="toggleEmptyHashtagsNavigator()" *ngIf="reportOid">
      <span style='font-size: 15px;  border: 1px solid;  border-radius: 8px; padding: 5px;'>{{'toolbar.emptyHashtagsNavigator' | translate}}</span>
    </button>
  </ng-container>
</div>
